<div class="relative w-full h-screen">
  <div
    class="absolute top-0 bottom-0 left-0 right-0 w-full h-screen flex items-center bg-black opacity-25"
  ></div>
  <div
    class="z-10 absolute top-0 bottom-0 left-0 right-0 w-full h-screen flex items-center justify-center mx-auto"
  >
    <div>
      <h1
        class="mb-8 w-9/12 mx-auto font-accent font-bold text-32px lg:text-5.8xl leading-10 lg:leading-14 text-white text-center"
      >
        {{ title }}
      </h1>
      <div class="flex justify-center">
        <a [link]="linkUrl">
          <app-button-atom
            class="mx-auto"
            [color]="'primary'"
            [type]="'primary'"
            [label]="linkLabel"
            [size]="'M'"
            [thickSize]="buttonSizeY"
          ></app-button-atom>
        </a>
      </div>
    </div>
  </div>
  <img
    class="w-full h-full object-cover"
    *ngIf="backgroundImage"
    [src]="backgroundImage.url"
    alt="Hero image"
  />
  <div class="absolute z-20 right-0 left-0 bottom-5 text-center">
    <a (click)="scrollTo()"><i class="icon icon-chevron-down cursor-pointer text-white"></i></a>
  </div>
</div>
